export const DuplicateTaskConstants = {
  maximumDuplicateLimit: 10,
  minimumDuplicateLimit: 1,
  notAssociatedWithAnyPhase: -1,
};
